// document.addEventListener('DOMContentLoaded', function () {
//   const toggle = document.getElementById('enableCustomSizing');
//   const fields = document.getElementById('customSizeFields');

//   if (toggle && fields) {
//     fields.classList.toggle('hidden', !toggle.checked);
//     fields.setAttribute('aria-hidden', String(!toggle.checked));

//     toggle.addEventListener('change', () => {
//       const show = toggle.checked;
//       fields.classList.toggle('hidden', !show);
//       fields.setAttribute('aria-hidden', String(!show));
//     });
//   }

//   const toInches = cm => Number((cm / 2.54).toFixed(2));
//   const toCm = inch => Number((inch * 2.54).toFixed(2));

//   document.addEventListener('input', function (e) {
//     const t = e.target;
//     if (!t.classList.contains('measure-cm') && !t.classList.contains('measure-inch')) return;

//     const val = t.value.trim();
//     const pair = t.classList.contains('measure-cm') ?
//                  t.parentElement.querySelector('.measure-inch') :
//                  t.parentElement.querySelector('.measure-cm');

//     if (!val) { pair.value = ''; return; }
//     const num = Number(val);
//     if (isNaN(num) || num < 0) { t.value = ''; pair.value=''; return; }

//     if (t.classList.contains('measure-cm')) pair.value = toInches(num);
//     else pair.value = toCm(num); 
//   });
// });


 
document.addEventListener('DOMContentLoaded', function () {
  const toggle = document.getElementById('enableCustomSizing');
  const fields = document.getElementById('customSizeFields');
  const link = document.getElementById('customSizingLink');

  if (toggle && fields) {
    fields.classList.toggle('hidden', !toggle.checked);
    fields.setAttribute('aria-hidden', String(!toggle.checked));

    toggle.addEventListener('change', () => {
      const show = toggle.checked;
      fields.classList.toggle('hidden', !show);
      fields.setAttribute('aria-hidden', String(!show));
    });
  }

  if (link && toggle) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      toggle.checked = !toggle.checked;
      this.classList.toggle('active', toggle.checked);
      toggle.dispatchEvent(new Event('change')); // trigger the change handler
    });
  }

  const toInches = cm => Number((cm / 2.54).toFixed(2));
  const toCm = inch => Number((inch * 2.54).toFixed(2));

  document.addEventListener('input', function (e) {
    const t = e.target;
    if (!t.classList.contains('measure-cm') && !t.classList.contains('measure-inch')) return;

    const val = t.value.trim();
    const pair = t.classList.contains('measure-cm') ? t.parentElement.querySelector('.measure-inch') : t.parentElement.querySelector('.measure-cm');

    if (!val) { pair.value = ''; return; }
    const num = Number(val);
    if (isNaN(num) || num < 0) { t.value = ''; pair.value = ''; return; }

    if (t.classList.contains('measure-cm')) pair.value = toInches(num);
    else pair.value = toCm(num);
  });

  
// document.addEventListener('click', function(e) {
//   if (e.target.id === "customSizingLink") {
//     // Find CS variant button and trigger click
//     const csOption = document.querySelector('[data-value="CS"]');
//     if (csOption) csOption.click();
//   }
// });

// --- Select CS variant ---
document.addEventListener('click', function (e) {
  if (e.target.id === "customSizingLink") {
    e.preventDefault();

    // Try radio button version
    const csRadio = document.querySelector('input[type="radio"][value="CS"]');
    if (csRadio) {
      csRadio.checked = true;
      csRadio.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Try button-based version
    const csButton = document.querySelector('[data-option-value="CS"]');
    if (csButton) {
      csButton.click();
    }
  }
});

// --- Show fields when CS is selected ---
document.addEventListener('change', function (e) {
  // Radio version
  if (e.target.matches('input[type="radio"][name="Size"]')) {
    const value = e.target.value;
    handleCSSelection(value === "CS");
  }
});


// document.addEventListener('click', function (e) {
//   // Button version
//   const btn = e.target.closest('[data-option-value]');
//   if (btn && btn.dataset.optionValue === "CS") {
//     handleCSSelection(true);
//   }
//   else if (btn && btn.dataset.optionValue !== "CS") {
//     handleCSSelection(false);
//   }
// });

function handleCSSelection(isCS) {
  const toggle = document.getElementById('enableCustomSizing');
  const fields = document.getElementById('customSizeFields');
  const link = document.getElementById('customSizingLink');

  if (isCS) {
    link.classList.add('active');
    toggle.checked = true;
    fields.classList.remove('hidden');
  } else {
    link.classList.remove('active');
    toggle.checked = false;
    fields.classList.add('hidden');
  }
}


// document.addEventListener('change', function(e){
//   if (e.target.name === "options[Size]") {
//     const selected = e.target.value;
//     if (selected === "CS") {
//       document.getElementById('customSizingLink').classList.add('active');
//       document.getElementById('enableCustomSizing').checked = true;
//       document.getElementById('customSizeFields').classList.remove('hidden');
//     } else {
//       document.getElementById('enableCustomSizing').checked = false;
//       document.getElementById('customSizeFields').classList.add('hidden');
//     }
//   }
// });



});



